import { render, staticRenderFns } from "./ModalFeePayment.vue?vue&type=template&id=789cd5b2&scoped=true"
import script from "./ModalFeePayment.vue?vue&type=script&lang=js"
export * from "./ModalFeePayment.vue?vue&type=script&lang=js"
import style0 from "./ModalFeePayment.vue?vue&type=style&index=0&id=789cd5b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789cd5b2",
  null
  
)

export default component.exports